<template>
  <el-row style="height: 50px">
    <el-col :span="24">
      <el-tabs type="border-card" v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="The overview" name="论文总览">
          <el-row>
            <el-table
                border
                :data="tableData.slice((currentPage-1)*pageSize,currentPage*pageSize)"
                v-loading="loading"
                style="width: 100%">
              <el-table-column
                  label="The meeting name"
                  prop="id">
                <template slot-scope="scope">
                  <a @click="toNext(scope.row.confId)" style="cursor: pointer;">{{scope.row.confName}}</a>
                </template>
              </el-table-column>
              <el-table-column
                  label="Paper title"
                  prop="thesisTitle">
              </el-table-column>
<!--              <el-table-column-->
<!--                  label="Submission venue"-->
<!--                  prop="subConfName">-->
<!--              </el-table-column>-->
              <el-table-column
                  label="Contributions of time"
                  sortable
                  prop="createTime">
              </el-table-column>
              <el-table-column
                  label="operation"
                  fixed="right"
              >
                <template slot-scope="scope">
                  <el-button
                      size="mini"
                      @click="change(scope.row.thesisId,scope.row.confId)">Check/modify</el-button>
                  <el-button
                      size="mini"
                      type="danger"
                      @click="Delete(scope.row.thesisId)">delete</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-row>
          <el-row style="margin-top: 10px">
            <el-pagination
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-size="pageSize"
                layout="total, prev, pager, next, jumper"
                :total="tableData.length">
            </el-pagination>
          </el-row>
        </el-tab-pane>
      </el-tabs>
    </el-col>
  </el-row>
</template>

<script>
export default {
name: "paper",
  data(){
    return{
      currentPage:1, //当前页数
      pageSize: 6 ,//每页条数


      activeName:'论文总览',
      tableData:[],
      loading: true,
    }
  },
  methods:{
    toNext(id){
      let routeData = this.$router.resolve({ path: '/signup',query:{id:id}
      });
      window.open(routeData.href, '_blank');
    },
    handleClick(){
    },
    //当前页改变时触发 跳转其他页
    handleCurrentChange(val) {
      this.currentPage = val;
    },
    //修改论文
    change(thesisId,confId){
      let id = window.localStorage.getItem("id")
      let routeData = this.$router.resolve(
          { path: '/paperUpload',
            query:{thesisId:thesisId,confId:confId,id:id}
          });
      window.open(routeData.href, '_blank');
    },
    // 删除论文
    async Delete(ssid){
      this.$confirm('Are you sure to delete this paper? It will not be retrieved after deletion!', 'tip', {
        confirmButtonText: 'yes',
        cancelButtonText: 'no',
        type: 'warning'
      }).then(async () => {
        const { data: res } = await this.$http.delete('api/conference/thesis/user/'+ssid)
        this.$message.success(res.msg)
        return location.reload()
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'canceled'
        });
      });
    },
    //获取论文列表
    async getList(){
      const { data: res } = await this.$http.get('api/conference/thesis/allListInUser')
      console.log(res);
      this.tableData = res.rows
      this.loading = false
    },
  },
  created() {
    this.getList()
  }
}
</script>

<style scoped lang="less">
.el-tab-pane{
  height: 500px;
  overflow: auto;
}
a{
  color: #1da7fe;
}
a:hover{
  color: red;
}
</style>
